import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import { useState } from 'react'
import { AddContactsTable } from '../../contact/AddContactsTable'
import OnboardingFooter from '../OnboardingFooter'
import OnboardingHeader from '../OnboardingHeader'

interface OnboardingStepAddContactsProps {
  onNext: () => void
  onBack: () => void
}

const OnboardingStepAddContacts: React.FC<OnboardingStepAddContactsProps> = ({
  onNext,
  onBack,
}) => {
  const [hasContacts, setHasContacts] = useState(false)

  const handleContactsChange = () => {
    setHasContacts(true)
  }

  return (
    <div className={css(styles.root)}>
      <div className={css(styles.content)}>
        <OnboardingHeader title="Add Contacts" progress={66} />
        <div className={css(styles.tableContainer)}>
          <AddContactsTable onChange={handleContactsChange} />
        </div>
      </div>
      <OnboardingFooter
        onNext={onNext}
        onBack={onBack}
        nextText="Next"
        disabled={!hasContacts}
      />
    </div>
  )
}

const styles = StyleSheet.create({
  title: {
    fontSize: 'clamp(22px, 3vw, 32px)',
    fontWeight: 600,
    color: '#1F3A8A',
    margin: 'clamp(12px, 2vw, 24px) 0 clamp(6px, 1vw, 16px) 0',
    textAlign: 'center',
  },
  progressBarContainer: {
    width: '100%',
    height: 8,
    background: '#E5E7EB',
    borderRadius: 8,
    marginBottom: 24,
    marginTop: 8,
  },
  progressBar: {
    height: 8,
    borderRadius: 8,
    background: '#2563EB',
    transition: 'width 0.3s',
  },
  progressBarStep2: {
    width: '66%',
  },

  buttonRow: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    gap: 16,
  },
  primaryButton: {
    background: '#2563EB',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    width: 74,
    fontSize: 'clamp(14px, 2vw, 16px)',
    fontWeight: 600,
    marginTop: 0,
    cursor: 'pointer',
    height: '48px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    marginBottom: 24,
  },
  secondaryButton: {
    background: '#fff',
    color: '#2563EB',
    border: '2px solid #2563EB',
    width: 74,
    borderRadius: 8,
    fontSize: 'clamp(14px, 2vw, 16px)',
    fontWeight: 600,
    cursor: 'pointer',
    height: '48px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    marginBottom: 24,
  },
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  tableContainer: {
    flex: 1,
    maxHeight: '400px',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
})

export default OnboardingStepAddContacts
